module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "acknowledgments"
    }
  }), _c('strong', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Learned something about ideas from just about everybody I ever taught or worked with. Any attempt to remember and name them all would fail. A sincere but sweeping “Thank you, everyone” must therefore suffice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks go to Tom Pflimlin, whose many suggestions helped me improve the first edition of this work; to Henry Caroselli and Mel Sant, whose many suggestions helped me improve this second edition; to Steven Piersanti and his staff, whose enthusiasm and knowledge and skill helped me transform a rough manuscript into a finished book, and a successful first edition into an even better second edition; and to my family, whose faith sustains me.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xiv-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 78
// module chunks = 0